define.alias("shared/components/shared/social/instagram-modal/unavailable-page", "calendar/components/shared/social/instagram-modal/unavailable-page");